import React, { useEffect, useState } from "react";
import axios from "axios";
import EmployeeProcessService from "../services/EmployeeProcessService";
import { toast } from "react-toastify";
import { useLoading } from "../Utils/LoadingContext";
import showToast from "../Utils/ToastContainer";

const HolidayUploadForm = () => {
  const { setLoading } = useLoading();
  const empcode = localStorage.getItem('empcode');
  const [file, setFile] = useState(null);
  const [year, setYear] = useState(new Date().getFullYear());
  const [plantList, setPlantList] = useState([]);
  const [plantCode, setPlantCode] = useState("");

  useEffect(() => {
    loadPlantDropdown();
  }, []);

  const loadPlantDropdown = async () => {
    try {
      const plantRes = await EmployeeProcessService.getPlant(empcode);
      if (plantRes?.data?.statusCode === 200) {
        setPlantList(plantRes.data.result);
      }
    } catch (error) {
      toast.error("Failed to load plants");
      console.error("Plant dropdown error:", error);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    debugger;
    if (!file || !year || !plantCode) {
      toast.warning("Please fill all fields and choose a file.");
      return;
    }
    const confirmed = window.confirm("Are you sure you want to Upload?");
    if (!confirmed) return; // Cancel save if user clicks "Cancel"
    const uploadData = new FormData();
    uploadData.append("file", file);
    uploadData.append("year", year);
    uploadData.append("plantCode", plantCode);

    try {
      setLoading(true);
      const response = await EmployeeProcessService.setHoliday(uploadData);

      if (response?.data?.result > 0) {
        showToast("Holiday calendar uploaded successfully.", "success");
        setFile(null);
        setPlantCode("");
      } else {
        toast.error("Upload failed. Please check file and try again.");
      }
    } catch (error) {
      console.error("Upload error:", error);
      toast.error("Upload failed.");
    } finally {
      setLoading(false);
    }
  };

  return (

    <form onSubmit={handleSubmit}>
      <div className="row">
        <div className="col-12 mb-3 border-bottom pb-2">
          <h4 className="text-left text-primary">Holiday Calendar</h4>
          <button
            type="button"
            onClick={async () => {
              const success = await EmployeeProcessService.getTemplate("HolidayList.xlsx");
              if (success) {
                showToast("Template downloaded successfully.", "success");
              }
            }}
            className="btn btn-outline-success"
          >
            Download Template
          </button>
        </div>
        <div className="form-group col-md-4">
          <label className="form-label">Year</label>
          <input
            type="number"
            value={year}
            onChange={(e) => setYear(e.target.value)}
            className="form-control"
            required
          />
        </div>

        <div className="form-group col-md-4">
          <label className="form-label">Plant <span className="text-danger">*</span></label>
          <select
            value={plantCode}
            onChange={(e) => setPlantCode(e.target.value)}
            className="form-select"
            required
          >
            <option value="">Select Plant</option>
            {plantList.map((plant) => (
              <option key={plant.id} value={plant.id}>
                {plant.name}
              </option>
            ))}
          </select>
        </div>

        <div className="form-group col-md-4">
          <label className="form-label">Excel File (.xlsx)</label>
          <input
            type="file"
            accept=".xlsx,.xls"
            className="form-control"
            onChange={(e) => setFile(e.target.files[0])}
            required
          />
        </div>
        <div className="col-12 mt-3 text-center">
          <button type="submit" className="btn btn-primary">
            Upload Holidays
          </button>
        </div>
      </div>
    </form>

  );
};

export default HolidayUploadForm;
